import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Form, Row } from "reactstrap";
import * as Yup from "yup";
import StyledButton from "../../components/Common/StyledButton";
import AddBranch from "../../components/CustomComponents/AddBranch";
import AddUser from "../../components/CustomComponents/AddUser";
import { getWarehouseListReq } from "../../service/branchService";
import { createClientReq } from "../../service/clientService";
import { setBreadcrumbItems } from "../../store/actions";

const CreateClient = (props) => {
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Client", link: "/clients" },
    { title: "Add new Client", link: "/client/add" },
  ];

  const [selectedFiles, setselectedFiles] = useState([]);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [warehouseList, setWarehouseList] = useState([]);
  const [status, setStatus] = useState("active")
  const [openModal, setOpenModal] = useState({
    status: false,
  });

  const searchAllWareHouses = async () => {
    try {
      const response = await getWarehouseListReq();
      setWarehouseList(response?.payload?.warehouses);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    searchAllWareHouses();
  }, []);

  const notify = (type, message, id) => {
    if (type === "Error") {
      toast.error(message, {
        position: "top-center",
        theme: "colored",
      });
    } else {
      toast.success(message, {
        position: "top-center",
        theme: "colored",
      });
      let path = `/client/${id}`;
      navigate(path);
    }
  };

  const handleCreateClient = async (values) => {
    try {
      const response = await createClientReq(values);
      if (response.success === true) {
        notify("Success", response.message, response.payload?.client._id);
      } else {
        notify("Error", response.message);
      }
      setIsButtonLoading(false);
    } catch (error) {
      notify("Error", error.message);
      setIsButtonLoading(false);
    }
  };



  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: null,
      contact: null,
      email: null,
      clientType: "individual",
      logo: "",
      gstin: null,
      pan: null,
      zohoCustomerId: "",
      poPrefix: "",
      status: "active",
      primaryBranch: {
        name: null,
        associatedWarehouse: "65f4b5d66959ec3852a37e60",
        contact: null,
        code: null,
        zohoAddressId: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pincode: "",
      },
      primaryUser: {
        firstName: null,
        lastName: null,
        email: null,
        contact: null,
        gender: null,
        role: "65b4e43b671d73cc3c1bbf90",
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Client Name"),
      contact: Yup.string()
        .matches(/^\d+$/, 'Contact number must only contain digits')
        .length(10, 'Contact number must be exactly 10 digits')
        .required('Contact number is required'),
      email: Yup.string().email("Please Enter Valid Email").required("Please Enter Client Email"),
      gstin: Yup.string().when('clientType',{
        is:(value)=>value !=='individual',
        then:(schema)=>
          schema
         .matches(/^[0-9A-Z]{15}$/, 'Invalid GST')
        .required("Please Enter GST Number"),
        otherwise:(schema)=>
          schema.notRequired()
      }),
       
      pan: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN')
        .required("Please Enter PAN Number"),
      zohoCustomerId: Yup.string().required("Please Enter Zoho Customer Id").matches(/^\d+$/,"zoho customer id contains only digits").length(19,"Zoho customer id cannot exceed 19 digits"),
      primaryBranch: Yup.object().shape({
        name: Yup.string().required("Please Enter Branch Name"),
        associatedWarehouse: Yup.string().required("Please Select Associated Warehouse"),
        contact: Yup.string().required("Please Enter Valid Contact Number"),
        code: Yup.string().required("Please Enter Branch Code").max(10,"Branch Code cannot exceed 10 character"),
        zohoAddressId: Yup.string()
            .matches(/^\d{10,20}$/, "Zoho Address ID must be a 10–20 digit number")
            .required("Please Enter Zoho Address Id"),
        addressLine1: Yup.string().required("Address Line 1 is required"),
        addressLine2: Yup.string(),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        pincode: Yup.string()
          .matches(/^[1-9][0-9]{5}$/, "Pincode must be a valid 6-digit number starting with 1–9")
          .required("Pincode is required"),
      }),
      primaryUser: Yup.object().shape({
        firstName: Yup.string().required("Please Enter First Name"),
        lastName: Yup.string().required("Please Enter Last Name"),
        email: Yup.string().email("Please Enter Valid Email").required("Please Enter Email Id"),
        contact: Yup.string()
          .matches(/^\d+$/, 'Contact number must only contain digits')
          .length(10, 'Contact number must be exactly 10 digits')
          .required('Contact number is required'),
        gender: Yup.string().required("Please Enter Gender"),
      }),
    }),
    onSubmit: (values) => {
      setIsButtonLoading(true);
      values.logo = `${selectedFiles[0]?.preview}`;
      values.status = status
      
      handleCreateClient(values);
    },
  });

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
  }

  const handleClientStatus = async (e) => {
    setStatus(e.target.value)
  };

  const onCreateClientClick = (e) => {
    e.preventDefault();
    validation.handleSubmit();
    return false;
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  useEffect(() => {
    props.setBreadcrumbItems("Add New Client", breadcrumbItems);
  });

  return (
    <Form className="form-horizontal mt-4" autoComplete="off">
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: -50,
            right: 10,
            display: "flex",
          }}
        >
          <select className="form-select focus-width" name="status" onChange={handleClientStatus}>
            <option value="active">Published</option>
            <option value="inactive">Draft</option>
          </select>
          <StyledButton
            color={"primary"}
            className={"w-md mx-2"}
            onClick={onCreateClientClick}
            isLoading={isButtonLoading}
          >
            Submit
          </StyledButton>
        </div>
        <Row>
          <Col xs="8">
            <Card>
              <CardBody>
                <Row>
                  <h4 className="card-title">Client Details</h4>
                </Row>
                <Row className="mt-4">
                  <Col xs="2">
                    <div className="rounded-circle text-center">
                      <label className="item-name text-center">
                        Client Logo
                      </label>
                      {selectedFiles.length > 0 ? (
                        <img
                          data-dz-thumbnail=""
                          style={{ borderRadius: "50%" }}
                          className="avatar-sm rounded- bg-light"
                          alt={selectedFiles[0].name}
                          src={selectedFiles[0].preview}
                        />
                      ) : (
                        <Dropzone
                          onDrop={(acceptedFiles) => {
                            handleAcceptedFiles(acceptedFiles);
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="rounded-circle">
                              <div
                                style={{
                                  background: "#ffffff",
                                  border: "1px solid #dee2e6",
                                }}
                                className="dz-message needsclick rounded-circle"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <i className="mdi mdi-36px mdi-cloud-upload-outline"></i>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="mt-4">
                      <label className="item-name">Client Name</label>
                      <input
                        name="name"
                        id="name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name
                        }
                        className="form-control"
                        type="text"
                        placeholder="Enter your Name"
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <p style={{ color: "red" }}>{validation.errors.name}</p>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <div className="mt-3">
                      <label className="item-name">Client Phone Number</label>
                      <input
                        name="contact"
                        id="contact"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.contact || ""}
                        invalid={
                          validation.touched.contact &&
                          validation.errors.contact
                        }
                        placeholder="Enter your number"
                      />
                      {validation.touched.contact &&
                        validation.errors.contact ? (
                        <p style={{ color: "red" }}>
                          {validation.errors.contact}
                        </p>
                      ) : null}
                    </div>
                  </Col>
                  <Col>
                    <div className="mt-3">
                      <label className="item-name">Primary Email</label>
                      <input
                        name="email"
                        id="email"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                        }
                        placeholder="Enter your email"
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <p style={{ color: "red" }}>
                          {validation.errors.email}
                        </p>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <div>
                    <label className="col-form-label">Client Type</label>
                    <select
                      name="clientType"
                      id="clinetType"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.clientType || ""}
                      invalid={
                        validation.touched.clientType &&
                        validation.errors.clientType
                      }
                      className="form-select focus-width"
                    >
                      <option>Select Client Type</option>
                      <option value="business">Business</option>
                      <option value="individual">Individual</option>
                    </select>
                    {validation.touched.clientType &&
                      validation.errors.clientType ? (
                      <p style={{ color: "red" }}>
                        {validation.errors.clientType}
                      </p>
                    ) : null}
                  </div>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <h4 className="card-title">Branch Details</h4>
                <AddBranch validation={validation} warehouseList={warehouseList} />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <h4 className="card-title">Additional Details</h4>
                <Row className="mt-4">
                  <Col>
                    <label className="item-name">Zoho Customer Id</label>
                    <input
                      name="zohoCustomerId"
                      id="zohoCustomerId"
                      className="form-control"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.zohoCustomerId}
                      invalid={
                        validation.touched.zohoCustomerId &&
                        validation.errors.zohoCustomerId
                      }
                      placeholder="Enter Zoho Customer Id"
                    />
                    {validation.touched.zohoCustomerId &&
                      validation.errors.zohoCustomerId ? (
                      <p style={{ color: "red" }}>
                        {validation.errors.zohoCustomerId}
                      </p>
                    ) : null}
                  </Col>
                  <Col>
                    <label className="item-name">PO Prefix</label>
                    <input
                      name="poPrefix"
                      id="poPrefix"
                      className="form-control"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.poPrefix}
                      invalid={
                        validation.touched.poPrefix &&
                        validation.errors.poPrefix
                      }
                      placeholder="Enter PO Prefix"
                    />
                    {validation.touched.poPrefix &&
                      validation.errors.poPrefix ? (
                      <p style={{ color: "red" }}>
                        {validation.errors.poPrefix}
                      </p>
                    ) : null}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xs="4">
            <Card>
              <CardBody>
                <h4 className="card-title">Tax Details</h4>
                <div className="mt-3">
                  <label className="item-name">PAN</label>
                  <input
                    name="pan"
                    id="pan"
                    className="form-control"
                    type="text"
                    placeholder="Enter PAN Number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.pan}
                    invalid={validation.touched.pan && validation.errors.pan}
                  />
                  {validation.touched.pan && validation.errors.pan ? (
                    <p style={{ color: "red" }}>{validation.errors.pan}</p>
                  ) : null}
                </div>
                <div className="mt-3">
                  <label className="item-name">GST Number</label>
                  <input
                    name="gstin"
                    id="gstin"
                    className="form-control"
                    type="text"
                    placeholder="Enter GST Number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.gstin}
                    invalid={
                      validation.touched.gstin && validation.errors.gstin
                    }
                  />
                  {validation.touched.gstin && validation.errors.gstin ? (
                    <p style={{ color: "red" }}>{validation.errors.gstin}</p>
                  ) : null}
                </div>
              </CardBody>
            </Card>
            <AddUser validation={validation} />
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default connect(null, { setBreadcrumbItems })(CreateClient);
